<template>
  <div class="siteWrap">
    <Header></Header>
    <div class="authWrap">
      <router-view />
      <Service></Service>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header";
import Footer from "@/components/footer"
import Service from "@/components/service"

import { mapGetters } from "vuex";
export default {
  name: 'TouristLayout',
  components: {
    Header,
    Footer,
    Service
  },
  computed: {
    ...mapGetters(["path"])
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {

  }

}
</script>

<style lang="scss" scoped>
.authWrap {
  width: 100%;
  padding-top: 180px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
</style>
